import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './layouts/layout.component';

// Auth
import { AuthGuard } from './core/guards/auth.guard';
import { CustomPreloadingStrategyService } from './core/services/custom-preloading-strategy.service';
import { MaintenanceComponent } from './extras/maintenance/maintenance.component';

const routes: Routes = [
  { path: '', component: LayoutComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), canActivate: [AuthGuard] },
  { path: 'auth', loadChildren: () => import('./account/account.module').then(m => m.AccountModule)  },
  { path: 'maintenance', component: MaintenanceComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: "enabled",preloadingStrategy: CustomPreloadingStrategyService })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
